export type LuckyIconName =
  | 'logo'
  | 'coin'
  | 'coin-gold'
  | 'coin-silver'
  | 'coin-bronze'
  | 'coin-diamond'
  | 'trophy'
  | 'gift'
  | 'calendar'
  | 'settings'
  | 'game'
  | 'leaderboard'
  | 'friends'
  | 'world'
  | 'rank'
  | 'challenge'
  | 'chest'
  | 'wallet'
  | 'life'
  | 'energy'
  | 'refresh'
  | 'help'
  | 'close'
  | 'confirm'
  | 'back'
  | 'next'
  | 'profile'
  | 'chat'
  | 'sound'
  | 'mute'

const iconModules = import.meta.glob('../../assets/lucky-icons/*.png', {
  eager: true,
  import: 'default',
}) as Record<string, string>

const ICONS = Object.fromEntries(
  Object.entries(iconModules).map(([path, url]) => {
    const file = path.split('/').pop() || ''
    const name = file.replace(/\.png$/i, '')
    return [name, url]
  }),
) as Record<string, string>

type Props = {
  name: LuckyIconName
  size?: number
  className?: string
  alt?: string
}

export function coinIconName(coinType: string): LuckyIconName {
  switch (coinType) {
    case 'diamond':
      return 'coin-diamond'
    case 'gold':
      return 'coin-gold'
    case 'silver':
      return 'coin-silver'
    case 'bronze':
      return 'coin-bronze'
    default:
      return 'coin'
  }
}

export default function LuckyIcon({ name, size = 28, className = '', alt = '' }: Props) {
  const src = ICONS[name]
  if (!src) return null

  return (
    <img
      src={src}
      width={size}
      height={size}
      alt={alt || name}
      draggable={false}
      className={`lucky-icon ${className}`.trim()}
      style={{ width: size, height: size }}
    />
  )
}
